import { ReactNode } from "react";

interface HProps {
  children: ReactNode;
}

export function H1({ children }: HProps) {
  return <h1 className="scroll-m-20 text-4xl font-bold tracking-tight lg:text-5xl mb-4">{children}</h1>;
}

export function H2({ children }: HProps) {
  return <h2 className="text-2xl font-bold tracking-tight mt-4 mb-2">{children}</h2>;
}

export function H3({ children }: HProps) {
  return <h3 className="text-xl font-bold tracking-tight mt-3 mb-1">{children}</h3>;
}

export function H4({ children }: HProps) {
  return <h4 className="text-lg font-bold tracking-tight mt-2">{children}</h4>;
}

export default {
  H1,
  H2,
  H3,
  H4,
};
